var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1281 17.28H12.8798V14.94C12.8798 13.6 12.2853 12.32 11.255 11.48L10.2048 10.62C9.8679 10.34 9.68956 9.94 9.68956 9.5C9.68956 9.06 9.88771 8.66 10.2246 8.38L11.2748 7.52C12.3052 6.66 12.8996 5.4 12.8996 4.06V1.72H14.148C14.6235 1.72 15 1.34 15 0.86C15 0.38 14.6235 0 14.148 0H0.852048C0.376486 0 0 0.38 0 0.86C0 1.34 0.376486 1.72 0.852048 1.72H2.1004V4.06C2.1004 5.4 2.69485 6.66 3.72523 7.52L4.75561 8.36C5.09247 8.64 5.29062 9.04 5.29062 9.48C5.29062 9.92 5.09247 10.32 4.77543 10.6L3.72523 11.48C2.69485 12.34 2.1004 13.6 2.1004 14.94V17.28H0.852048C0.376486 17.28 0 17.66 0 18.14C0 18.62 0.376486 19 0.852048 19H14.148C14.6235 19 15 18.62 15 18.14C15 17.66 14.6037 17.28 14.1281 17.28ZM3.82431 14.94C3.82431 14.12 4.18098 13.34 4.81506 12.82L5.86526 11.96C6.59841 11.36 7.01453 10.46 7.01453 9.5C7.01453 8.54 6.59841 7.64 5.84544 7.04L4.81506 6.2C4.18098 5.66 3.80449 4.9 3.80449 4.08V1.72H11.1559V4.06C11.1559 4.88 10.7992 5.66 10.1651 6.18L9.13474 7.04C8.40158 7.64 7.96565 8.54 7.96565 9.5C7.96565 10.46 8.38177 11.34 9.11493 11.96L10.1651 12.82C10.7992 13.34 11.1559 14.12 11.1559 14.94V17.28H3.82431V14.94Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingWhite);
export default __webpack_public_path__ + "static/media/pending-white.ff067d35e0af804da8b44f2568902c6d.svg";
export { ForwardRef as ReactComponent };